import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { get } from "../../../../utils/api";
import MultiColumns from "../MultiColumns";

import { companyId } from "../../../../utils/companyId";

const Diversity = ({ isEditing }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/social/diversity_inclusion/${companyId}`);
        // Update state only if data is available
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const questionary = [
    { mainheading: "Gender Diversity", gridSize: { xs: 12 } },
    {
      key: "genderDiversity.womenInWorkforce.value",
      key2: "genderDiversity.womenInWorkforce.unit",
      question: "% of women in workforce",
      gridSize: { xs: 12, sm: 6, md: 4 },
    },
    {
      key: "genderDiversity.womenInManagement.value",
      key2: "genderDiversity.womenInManagement.unit",
      question: "% of women in management",
      gridSize: { xs: 12, sm: 6, md: 4 },
    },
    {
      key: "genderDiversity.womenInBoard.value",
      key2: "genderDiversity.womenInBoard.unit",
      question: "% of women in board",
      gridSize: { xs: 12, sm: 6, md: 4 },
    },
    {
      key: "representationOfMinorities.minorityEmployees.value",
      key2: "representationOfMinorities.minorityEmployees.unit",
      question: "% of minority employees",
      gridSize: { xs: 12 },
    },
    { mainheading: "Pay Equity", gridSize: { xs: 12 } },
    { key: "payEquity.malePayGap", question: "Male pay gap" },
    { key: "payEquity.femalePayGap", question: "Female pay gap" },
    { key: "payEquity.minorityPayGap", question: "Minority pay gap" },
    { key: "payEquity.majorityPayGap", question: "Majority pay gap" },
    {
      mainheading: "Initiatives for Diversity and Inclusion",
      gridSize: { xs: 12 },
    },
    {
      key: "initiativesForDiversityAndInclusion",
      subkey: "initiative",
      question: "Initiative",
    },
    {
      key: "initiativesForDiversityAndInclusion",
      subkey: "effectiveness",
      question: "Effectiveness",
    },
  ];

  return (
    <>
      <MultiColumns
        title="DIVERSITY & INCLUSION"
        url={`/social/diversity`}
        questionary={questionary}
        columns={2}
        data={data}
        isEditing={isEditing}
      />
    </>
  );
};

export default Diversity;
